import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import {
  getDealInfoByType,
  getChannelForWidget,
} from '@wix/wix-vod-shared/common';

import ItemInfoPage from './item-info-page/item-info-page';
import PaymentsPage from './payments-page/payments-page';
import PaymentCompletePage from './payment-complete-page/payment-complete-page';

import { getOrderId } from '../../../selectors/payment';
import { getCurrentSiteUser } from '../../../selectors/current-site-user';

import { getVideoById } from '../../../selectors/videos';
import { openPaymentModalAfterReload } from '../../../utils/handle-logout-payment-modal';

import styles from './cashier-payment-modal.scss';
import { PAYMENT_STEPS } from '../../../full-screen-modals/views/payment/constants';

const mapStateToProps = (state, { videoId }) => {
  return {
    orderId: getOrderId(state),
    itemData: videoId
      ? getVideoById(state, videoId)
      : getChannelForWidget(state),
    user: getCurrentSiteUser(state),
  };
};

const CashierPaymentModal = connect(mapStateToProps)(
  class CashierPaymentModal extends React.Component {
    static propTypes = {
      itemData: PropTypes.object,
      paymentType: PropTypes.string,
      user: PropTypes.object,
      onUserLogin: PropTypes.func.isRequired,
      onLogOut: PropTypes.func,
      onPaymentTypeChange: PropTypes.func.isRequired,
      onPaymentMethodChange: PropTypes.func.isRequired,
      onPaymentStart: PropTypes.func.isRequired,
      onPaymentComplete: PropTypes.func.isRequired,
      orderId: PropTypes.string,
      className: PropTypes.string,
      onClose: PropTypes.func.isRequired,
      isMobile: PropTypes.bool,
      step: PropTypes.number,
      onStepChange: PropTypes.func,
    };

    static defaultProps = {
      step: PAYMENT_STEPS.INFO,
      onStepChange: _.noop,
    };

    toInfoStep = () => {
      this.props.onStepChange(PAYMENT_STEPS.INFO);
    };

    toPaymentStep = () => {
      this.props.onStepChange(PAYMENT_STEPS.PAYMENT);
    };

    toPaymentCompleteStep = () => {
      this.props.onStepChange(PAYMENT_STEPS.SUCCESS);
    };

    handleLogOut = () => {
      const { paymentType, onLogOut } = this.props;

      openPaymentModalAfterReload(paymentType);
      onLogOut();
    };

    renderStep = () => {
      const {
        itemData,
        paymentType,
        user,
        onPaymentTypeChange,
        onPaymentMethodChange,
        onPaymentStart,
        onClose,
        onUserLogin,
        isMobile,
        step,
      } = this.props;

      const dealInfo = getDealInfoByType(itemData.dealInfo, paymentType);

      switch (step) {
        case PAYMENT_STEPS.INFO:
          return (
            <ItemInfoPage
              itemData={itemData}
              user={user}
              onUserLogin={onUserLogin}
              onPaymentTypeChange={onPaymentTypeChange}
              paymentType={paymentType}
              onLogOut={this.handleLogOut}
              handleNextStep={this.toPaymentStep}
            />
          );

        case PAYMENT_STEPS.PAYMENT:
          return (
            <PaymentsPage
              itemData={itemData}
              paymentType={paymentType}
              user={user}
              onLogOut={this.handleLogOut}
              handleReturnClick={this.toInfoStep}
              onPaymentStart={onPaymentStart}
              onPaymentComplete={this.toPaymentCompleteStep}
              onPaymentMethodChange={onPaymentMethodChange}
            />
          );

        case PAYMENT_STEPS.SUCCESS:
          return (
            <PaymentCompletePage
              onCloseClick={onClose}
              dealInfo={dealInfo}
              isMobile={isMobile}
            />
          );

        default:
          return null;
      }
    };

    render() {
      const { className, step } = this.props;

      return (
        <div
          data-hook="payment-modal"
          className={classnames(styles.responsiveWrapper, className, {
            [styles.successStep]: step === PAYMENT_STEPS.SUCCESS,
            [styles.infoStep]: step === PAYMENT_STEPS.INFO,
            [styles.paymentStep]: step === PAYMENT_STEPS.PAYMENT,
          })}
        >
          {this.renderStep()}
        </div>
      );
    }
  },
);

export default CashierPaymentModal;
